import store from '@/store/index.js'
const router_domain_url = store.state.router_domain_url

// 异步请求处理
/**
 *
 * @param {路径} path
 * @param {组件路径} file
 * @param {别名，没有传null } name
 * @param {说明，没有就传{} } meta
 * @param {子级，没有子级可以不传} children
 */ 
function route(path, file, name, meta, children, redirect) {
  return {
    exact: true,
    path,
    name,
    meta,
    children,
    redirect,
    component: () => import(`@/views/customization/${router_domain_url}/pages/${file}`)
  }
}
const indexRouterlist = [
  route('/quick-purchase', 'quickPurchase/index', '', { title: '快速购买', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: true }),
  // 自营商城
  route('/selfSupportShopping', 'selfShopping/selfSupportShopping', '', { title: '自营商城', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: true }),
  route('/selfGoodDetail', 'selfShopping/selfGoodDetail', '', { title: '自营商城详情', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/selfGoodsList', 'selfShopping/selfGoodsList', '', { title: '自营商城列表', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/checkout-alternative-self', 'Orders/CheckoutAlternativeSelf', 'CheckoutAlternativeSelf', { title: '提交订单', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/order-pay-self', 'Orders/orederPaySelf', 'orederPaySelf', { title: '待支付', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: true }),
]
const personRouterlist = [
  route('/cmcc-money-card', 'user/cmccMoneyCard', 'CmccMoneyCard', { title: '包月卡', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/order-pack-details', 'Orders/OrderPackDetails', 'OrderPackDetails', { title: '转运包裹详情', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/self-order-list', 'Orders/selfOrderList', 'selfOrderList', { title: '好物订单列表', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/self-order-details', 'Orders/SelfOrderDetails', 'SelfOrderDetails', { title: '代购订单详情', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: true }),

   // 推广返利
   route('/invitationCode', 'share/invitationCode', '', { title: '邀请码', ssr: true, pageWidth: true, keepAlive: false, requireAuth: true }),
   route('/coupon-list', 'share/inviteReturnCouponList', '', { title: '返券明细', ssr: true, pageWidth: true, keepAlive: false, requireAuth: true }),
   route('/relevancy-user', 'share/relevancyUser', '', { title: '关联用户', ssr: true, pageWidth: true, keepAlive: false, requireAuth: true }),
]
export default {
  indexRouterlist: indexRouterlist,
  personRouterlist:personRouterlist,
}
